import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

var noop = function noop(_) {
  return _;
};

var _cache = new Map();

var _inFlightCache = new Map();

var _cacheSubscribers = new Map();

function getSubscribers(scheme) {
  var subscribers = _cacheSubscribers.get(scheme);

  if (!subscribers) {
    subscribers = new Set();

    _cacheSubscribers.set(scheme, subscribers);
  }

  return subscribers;
}

export var Cache = {
  set: function set(scheme, data) {
    _cache.set(scheme, data);
  },
  get: function get(key) {
    return _cache.get(key);
  },
  has: function has(key) {
    return _cache.has(key);
  },
  delete: function _delete(scheme) {
    _cache.delete(scheme);
  },
  set$: function set$(scheme) {
    var updater = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    if (Cache.has(scheme) === false) return;
    var cached = Cache.get(scheme);
    var updated = updater(cached);
    Cache.set(scheme, updated);

    var subscribers = _cacheSubscribers.get(scheme);

    if (subscribers) {
      subscribers.forEach(function (subscriber) {
        return subscriber(updated);
      });
    }
  },
  get$: function get$(scheme, subscriber) {
    if (!process.browser) return noop;
    var subscribers = getSubscribers(scheme);
    subscribers.add(subscriber);
    return function () {
      subscribers.delete(subscriber);
    };
  },
  getInFlightQuery: function getInFlightQuery(scheme) {
    return _inFlightCache.get(scheme);
  },
  setInFlightQuery: function setInFlightQuery(scheme, options, promise) {
    var cachedScheme = getCacheScheme(scheme, options);

    _inFlightCache.set(cachedScheme, promise.catch(function (e) {
      _inFlightCache.delete(cachedScheme);

      return Promise.reject(e);
    }));
  }
};
export var getCacheScheme = function getCacheScheme(scheme, options) {
  return (options === null || options === void 0 ? void 0 : options.variables) ? scheme + JSON.stringify(options.variables) : scheme;
};
export var schemeCacheSetter = function schemeCacheSetter(scheme, options) {
  return function (data) {
    var cachedScheme = getCacheScheme(scheme, options);
    Cache.set(cachedScheme, data);

    _inFlightCache.delete(cachedScheme);

    if (options === null || options === void 0 ? void 0 : options.cacheTime) {
      setTimeout(function () {
        return _cache.delete(cachedScheme);
      }, options.cacheTime * 1000);
    }

    return data;
  };
};
var wasSsrClientCached = false;
export function newSsrClientCacher(clb) {
  if (!process.browser) return noop;
  return function () {
    if (wasSsrClientCached) return;

    var _clb = clb.apply(void 0, arguments),
        _clb2 = _slicedToArray(_clb, 2),
        scheme = _clb2[0],
        data = _clb2[1];

    Cache.set(scheme, data);
    wasSsrClientCached = true;
  };
}
export var CachePolicy;

(function (CachePolicy) {
  CachePolicy[CachePolicy["NewCache"] = 1] = "NewCache";
})(CachePolicy || (CachePolicy = {}));